"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var templateAreas = _a.templateAreas;
    if (!templateAreas) {
        return '';
    }
    if (Array.isArray(templateAreas) && templateAreas.length > 0) {
        return "grid-template-areas: " + templateAreas.map(function (line) { return "\"" + line + "\""; }).join(' ') + ";";
    }
    console.error('Please provide an array of strings for `templateAreas` style helper.');
    return '';
});
